import { useAuth } from 'react-oidc-context';
import { getProjectRoles } from 'lib/auth/authUtils';

// Zitadel project-role key that grants the Bhoonidhi-only catalog experience.
// Must match the role name created in Zitadel EXACTLY (case-sensitive), and the
// backend gate require_role("Bhoonidhi").
export const BHOONIDHI_ROLE = 'Bhoonidhi';

// True when the current user's token carries the `Bhoonidhi` project role.
// Reads the token roles claim (not the single `role` on /api/me), so it's
// correct for users holding multiple roles.
export const hasBhoonidhiRole = () => getProjectRoles().includes(BHOONIDHI_ROLE);

// Reactive variant — re-evaluates as OIDC auth settles. A user with this role
// gets the Bhoonidhi-only shell (Task tab hidden, catalog source forced to
// Bhoonidhi, and Checkout stages the selection into the Bhoonidhi cart via a
// trimmed review popup that redirects to the portal).
//
// Reads roles from the REACTIVE `auth.user.access_token`, NOT the in-memory
// tokenStore behind `hasBhoonidhiRole()`: that store is filled by TokenSync one
// render AFTER auth restores and isn't reactive, so on reload it briefly reports
// "not Bhoonidhi" and sticks there (flashing the wrong shell / nav). Mirrors the
// fix already in useIsImintUser.
export const useIsBhoonidhiUser = () => {
  const auth = useAuth();
  return !!auth.isAuthenticated && getProjectRoles(auth.user?.access_token).includes(BHOONIDHI_ROLE);
};
